import React, { useEffect, useRef, useState } from "react";
import { Label } from "reactstrap";
import CoreInvoiceInput from "./core-invoice-input";
import CircularLoader from "../../assets/images/icons/circular-spinner.svg";
import CancelIcon from "../../assets/images/icons/cancel-icon.svg";
import { connect } from "react-redux";
import { invoiceCreationService } from "../../_services/invoiceCreation.service";
import { alertActions } from "../../_actions";
import { appConstants } from "../../_constants";
import { debounce } from "lodash";
import OtpModal from "./OtpModal";
import { store } from "react-notifications-component";
import { Switch } from "antd";
import moment from "moment";

const IndividualInvoiceFieldForm = (props) => {
  const {
    dispatch,
    invoiceCustomerData,
    setInvoiceCustomerData,
    invoiceTableData,
    setInvoiceTableData,
    individualsSelfServiceTypes,
    isFetchingServices,
    agencyId,
  } = props;
  const validateNinRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [fetchingNin, setFetchingNin] = useState(false);
  const [ninInfo, setNinInfo] = useState(null);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [stage, setStage] = useState(1);
  const [isOtpValid, setIsOtpValid] = useState(false);
  const [showEmailError, setShowEmailError] = useState(false);
  const [showNinError, setShowNinError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    // Clear error notes
    if (name === "email" && showEmailError) {
      setShowEmailError(false);
    }

    if (name === "nin") {
      formattedValue = value.replace(/\D/g, "").slice(0, 11); // only digits, max 11
      setNinInfo(null); // reset NIN info if editing again
      if (isOtpValid === true) {
        setIsOtpValid(false);
      }

      setInvoiceCustomerData((prev) => ({
        ...prev,
        [name]: formattedValue,
      }));

      if (formattedValue.length === 11) {
        setFetchingNin(true);
        validateNin(formattedValue);
      } else {
        validateNin.cancel(); // cancel debounce if user deletes characters
        setFetchingNin(false);
      }
    } else {
      setInvoiceCustomerData((prev) => ({
        ...prev,
        [name]: formattedValue,
      }));
    }
  };

  const createIndividualInvoice = (payload) => {
    dispatch(alertActions.startRequest());
    invoiceCreationService
      .createIndividualInvoice(payload)
      .then((res) => {
        setIsLoading(false);
        dispatch(alertActions.stopRequest());
        let response = res.response;

        if (res.status === appConstants.SUCCESS_RESPONSE) {
          window.location.href =
            response?.invoice?.billerUrl || "/invoice-initation";
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          store.addNotification({
            title: "Error",
            message:
              res?.response?.message || "An error occurred please try again",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 5000,
            },
          });
        }
      })
      .catch((err) => {
        store.addNotification({
          title: "Error",
          message:
            err?.response?.message || "An error occurred please try again",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 5000,
          },
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleProceed = () => {
    if (stage === 1) {
      setStage(2);
    }

    if (stage === 2) {
      // Proceed if email is provided
      if (invoiceCustomerData.email) {
        
        setShowEmailError(false);
        // Checks if NIN is valid
        if (isOtpValid === true) {
          setIsLoading(true);
          const payload = {
            invoiceDate: moment().format("YYYY-MM-DD"),
            // TODO: revenueId: parseInt(invoiceTableData?.serviceType) || "2371",
            // ToDO: remove the hardcoded values - customerAIN, locationId
            revenueId: parseInt(invoiceTableData?.serviceType),
            customerAIN: "1030000001",
            currencyId: 566,
            locationId: 9,
            emails: invoiceCustomerData?.email,
            name: invoiceCustomerData?.customerName || "",
            phone: invoiceCustomerData?.phone || "",
            address: invoiceCustomerData?.address || "",
            bills: [
              {
                description: invoiceTableData?.description,
                quantity: invoiceTableData?.quantity,
                rate: invoiceTableData?.amount,
                amount:
                  (parseInt(invoiceTableData?.quantity) *
                    parseFloat(invoiceTableData?.amount)) |
                  0,
              },
            ],
            RevenueGroupId: invoiceTableData?.revenueGroupId || null,
            rrr: "",
            enableCredit: false,
            // TODO: remove the hardcoded values - userId
            userId: "48240317-22a8-4e48-b361-1875648a86e1",
            checkSimilarInvoice: false,
            // TODO: remove the hardcoded values - agencyId
            // agencyId: agencyId,
            agencyId: 10,
          };
          createIndividualInvoice(payload);
        } else {
          store.addNotification({
            title: "Error",
            message: "Validate your NIN to proceed",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 5000,
            },
          });
        }
      } else {
        setShowEmailError(true);
      }
    }
  };

  const validateNin = debounce((nin) => {
    const payload = { nin: nin };
    dispatch(alertActions.startRequest());

    const currentRequest = invoiceCreationService.validateNin(payload);

    validateNinRef.current = currentRequest;

    currentRequest
      .then((res) => {
        setFetchingNin(false);
        dispatch(alertActions.stopRequest());

        if (res.status === appConstants.SUCCESS_RESPONSE) {
          if (res?.response?.data) {
            setNinInfo(res?.response?.data || null);
          }

          store.addNotification({
            title: "Success",
            message:
              res?.response?.message ||
              "An Otp has been sent to the number attached to this NIN",
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 5000 },
          });

          setShowOtpModal(true);
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          setNinInfo(null);
          store.addNotification({
            title: "Error",
            message: res?.response?.message || "Error validating NIN",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 5000,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setFetchingNin(false);
      });
  }, 500); // runs after 500ms of no typing

  useEffect(() => {
    const body = document.body;

    if (!showOtpModal) {
      // Only remove "overflow: hidden" if it exists
      if (body.style.overflow === "hidden") {
        body.style.overflow = "scroll";
      }
    }

    // Optional cleanup to reset when component unmounts
    return () => {
      body.style.overflow = "";
    };
  }, [showOtpModal]);

  return (
    <div className="organisation-invoice-request-form">
      <div>
        {stage === 1 ? (
          <>
            <p className="individual-instruction">
              Select your service type to proceed
            </p>
            <hr />
          </>
        ) : (
          <>
            <p className="person-dets-header">Personal details</p>
            <p className="person-dets-instruction">
              Kindly input your NIN for validation
            </p>
          </>
        )}

        {stage === 1 ? (
          <CoreInvoiceInput
            invoiceTableData={invoiceTableData}
            setInvoiceTableData={setInvoiceTableData}
            serviceList={individualsSelfServiceTypes}
            isFetchingServices={isFetchingServices}
          />
        ) : (
          <>
            <div>
              <Label className="entity-auth-label">NIN</Label>
              <div className="input-container">
                <input
                  className={`no-spinner-input entity-auth-label-dropdown`}
                  type="text"
                  name="nin"
                  value={invoiceCustomerData?.nin}
                  onChange={handleChange}
                  maxLength={11}
                  inputMode="numeric"
                  pattern="\d*"
                  disabled={fetchingNin}
                />
                {fetchingNin && (
                  <img
                    src={CircularLoader}
                    alt="loader icon"
                    className={`activity-icon loading`}
                  />
                )}
              </div>
              <p className="nin-guide-text">
                We will send you a 6 digit pin to confirm you are the owner of
                this NIN
              </p>
            </div>

            {ninInfo && isOtpValid && (
              <div className="validated-person-info">
                <p>
                  <span className="label">Name</span>
                  <span className="value">
                    {invoiceCustomerData?.customerName || "-------"}
                  </span>
                </p>
                <p>
                  <span className="label">Gender</span>
                  <span className="value">
                    {invoiceCustomerData?.gender || "-------"}
                  </span>
                </p>
                <p>
                  <span className="label">Phone number</span>
                  <span className="value">
                    {invoiceCustomerData?.phone || "-------"}
                  </span>
                </p>
                <p>
                  <span className="label">Address</span>
                  <span className="value">
                    {invoiceCustomerData?.address || "-------"}
                  </span>
                </p>
              </div>
            )}
            <div>
              <Label className="entity-auth-label">Email address</Label>
              <input
                className={`no-spinner-input entity-auth-label-dropdown ${
                  showEmailError ? "error-border" : ""
                }`}
                type="email"
                name="email"
                value={invoiceCustomerData?.email}
                onChange={handleChange}
              />
              {showEmailError && <p className="email-error">Email is required!</p>}
            </div>
            <div className="person-dets-sms-container">
              <p className="person-dets-sms">
                Send invoice via sms <span>(additional charges apply)</span>{" "}
              </p>
              <Switch />
            </div>
          </>
        )}
      </div>
      <div>
        {stage === 1 ? (
          <button
            className="entity-auth-button"
            disabled={
              isLoading ||
              !invoiceTableData?.serviceType ||
              !invoiceTableData?.quantity ||
              !invoiceTableData?.amount
            }
            onClick={handleProceed}
          >
            {isLoading ? "Processing..." : "Continue"}
          </button>
        ) : (
          <div className="flexed-button-container">
            <button
              className="entity-auth-outline-button"
              onClick={() => setStage(1)}
            >
              Back
            </button>
            <button
              className="entity-auth-button"
              disabled={isLoading || !invoiceCustomerData?.nin}
              onClick={handleProceed}
            >
              {isLoading ? "Processing..." : "Make payment"}
            </button>
          </div>
        )}
      </div>
      {showOtpModal && (
        <OtpModal
          ninInfo={ninInfo}
          validateNin={validateNin}
          setShowOtpModal={setShowOtpModal}
          showOtpModal={showOtpModal}
          invoiceCustomerData={invoiceCustomerData}
          setInvoiceCustomerData={setInvoiceCustomerData}
          setIsOtpValid={setIsOtpValid}
          setNinInfo={setNinInfo}
        />
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const {
    alert,
    user,
    requesting,
    userData,
    displayGeneralAlert,
    branding,
    agencyId,
  } = state;
  return {
    alert,
    user,
    requesting,
    userData,
    displayGeneralAlert,
    branding,
    agencyId: state.agency ? state.agency.agencyId : null,
  };
}

export default connect(mapStateToProps)(IndividualInvoiceFieldForm);
